export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10264.0a150ad7.jpg";